import {Divider, Spin} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import AuthContext from "../utilis/contexts/AuthContext";
import AppContext from "../utilis/contexts/AppContext";
import InfiniteScroll from "react-infinite-scroll-component";
import Texts from "../utilis/defaults/Text";
import LocalStorage from "../utilis/tools/LocalStorage";

const MyTransactions = () => {
    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext)
    const [transactions, setTransactions] = useState([]);
    const Token=LocalStorage.getToken();
    const [state, setState] = useState<any>({
        items: [],
        hasMore: false
    })
    useEffect(() => {
        if (transactions.length) {
            setState({
                items: transactions.slice(0, 10),
                hasMore: transactions.length > 10
            })
        }
    }, [transactions])
    const fetchMoreData = () => {

        if (!state.hasMore) {
            return;
        }
        
        setTimeout(() => {
            setState({
                items: state.items.concat(transactions.slice(state.items.length, state.items.length + 10 > transactions.length ? transactions.length : state.items.length + 10)),
                hasMore: state.items.length + 10 < transactions.length
            });
        }, 1000);
    };

    useEffect(() => {
        if (authContext.Token) {
            appContext.handleLoading(true)

            Api.post(Urls.GetBillTransactions, {
                Cellphone: authContext.user.cellphone,
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Data} = data;
                const {transactions} = Data;
                setTransactions(transactions)
                
            }).catch((e: AxiosError) => {

            }).finally(() => {

                appContext.handleLoading(false)


            })
        }
    }, [])
    return <>
        <Divider><h3 className="font-bold ">لیست تراکنش ها</h3></Divider>
        <InfiniteScroll
            dataLength={state.items.length}
            next={fetchMoreData}
            hasMore={state.hasMore}
            loader={<div className="flex w-full mb-3 justify-center"><Spin/></div>}

        >
            {state.items.map((i: any, index: number) => (
                <div className="bg-gray-50 border-gray-200 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-2 w-full mb-3 mb-2 gap-4 rounded-lg p-4 " key={index}>
                    <div className="flex text-sm justify-start items-center">
                        <strong className="ml-2">شناسه قبض : </strong><span>{i.bill_id}</span>
                    </div>
                    <div className="flex text-sm justify-start items-center">
                        <strong className="ml-2">شناسه پرداخت : </strong><span>{i.pay_id}</span>
                    </div>
                    <div className="flex  text-sm justify-start items-center">
                        <strong className="ml-2">کد رهگیری : </strong><span>{i.trace_number}</span>
                    </div>
                    <div className="flex text-sm justify-start items-center">
                        <strong className="ml-2">شماره کارت  : </strong><span>{i.card_number}</span>
                    </div>
                    <div className="flex text-sm justify-start items-center">
                        <strong className="ml-2">تاریخ  : </strong><span>{i.date}</span>
                    </div>

                    <div className="flex  text-sm justify-start items-center">
                        <strong className="ml-2"> مبلغ :  </strong><span>{i.amount}{Texts.moneyUnit}</span>
                    </div>
                </div>
            ))}
        </InfiniteScroll>

    </>
}
export default MyTransactions;